export const Permissions = {
    ADMIN: 'ADMIN',
    REPRESENTANTE: 'REPRESENTANTE',
};